import React from 'react';

type StatusType = 'submitted' | 'approved' | 'rejected'|'pending'|'draft'|'sendback'|'recheck'|'deactivate'|'left';

interface StatusBadgeProps {
  status: StatusType;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const statusClasses: Record<StatusType, string> = {
    submitted: 'bg-amber-100 text-amber-800',
    approved: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
    pending: 'bg-yellow-100 text-yellow-800',
    draft:'bg-gray-200 text-gray-800',
    sendback:'bg-orange-100 text-orange-800',
    recheck:'bg-purple-100 text-purple-800',
    deactivate:'bg-red-100 text-red-800',
    left:"bg-red-100 text-red-800",
  };
  return (
    <span
      className={`px-2 py-1 rounded-full text-xs  capitalize ${
        statusClasses[status]
      }`}
    >
      {status}
    </span>
  );
};
export default StatusBadge;
